import { createKeyvalStorage } from '$logic/lib/keyval.storage'

const key = 'onboarding-actions'
const onboardingKeyValStorage = createKeyvalStorage<{ actions: string[] }>(key)

export const onboardingStorage = {
  async addActions(newActions: string[]) {
    const actions = onboardingStorage.getActions()

    if (!actions) {
      await onboardingKeyValStorage.set({ actions: newActions })
      return
    }

    const actionsSet = new Set([...actions, ...newActions])

    await onboardingKeyValStorage.set({ actions: Array.from(actionsSet) })
  },

  getActions() {
    try {
      return onboardingKeyValStorage.get()?.actions
    } catch (e) {
      return undefined
    }
  },
}
